// Règles d'affichage de l'écran du jour, sans React : testées seules.
import type { JourComplet } from './api';

/** Le texte de la source s'affiche si la prise arrive (ou n'est pas arrivée) après la fenêtre. */
export function enRetard(j: JourComplet, maintenant: Date): boolean {
  if (j.jour.genre !== 'actif') return false;
  if (j.prise) return j.prise.statut === 'apres-delai';
  return maintenant > j.finFenetre;
}
